module.exports = __webpack_public_path__ + "static/media/ic_sec_energy.ae078191.svg";